<template>
  <div>
    <div class="alert alert-warning" role="alert" v-if="!!errorText">
      {{ errorText }}
    </div>
    <div v-if="!expiresTime">
      <div class="row m-2">
        <div class="col-md-12">
          {{ trans('phone.step1.description') }}
        </div>
      </div>
      <div class="row m-2">
        <label for="mobile_phone_number" class="col-md-3 col-form-label text-md-right"> {{ trans('phone.step1.phone') }} </label>
        <div class="col-md-6">
          <input-phone-component prefix="+47" v-model="phone" />
        </div>
      </div>
      <div class="row m-2">
        <div class="col-md-9 offset-md-3">
          <button
            class="btn btn-success"
            @click="enterPhone"
            :disabled="!phone||phone.length!==8">{{trans('phone.step1.button')}}</button>
        </div>
      </div>

    </div>
    <div v-else>
      <div class="alert alert-info m-2" role="alert">
        {{ trans('phone.step2.description') }} +47{{ phone }} <br>
        {{ trans('phone.step2.expires') }} {{ expiresTime.local().format('DD.MM.YYYY HH:mm') }} <br>
        <button type="button" class="btn btn-link p-0" @click="resetPhone">
          {{ trans('phone.step2.reset') }}
        </button>
      </div>
      <div class="row m-2">
        <label for="mobile_phone_code" class="col-md-3 col-form-label text-md-right"> {{ trans('phone.step2.code') }} </label>

        <div class="col-md-6">
          <div class="input-group">
            <input
              id="mobile_phone_code"
              name="mobile_phone_code"
              type="text"
              class="form-control"
              required=""
              autofocus=""
              v-model="code"
              size="10"
              maxlength="6"
            >
          </div>
        </div>
      </div>
      <div class="row m-2">
        <div class="col-md-9 offset-md-3">
          <button
            class="btn btn-success"
            @click="enterCode"
            :disabled="!code||!phone||code.length!==6"
          >
            {{ trans('phone.step2.button') }}
          </button>
        </div>
        <div class="col-md-9 offset-md-3">
          <button type="button" class="btn btn-link px-0" @click="enterPhone" :disabled="remain>0">
            {{ trans('phone.step2.resend') }}
            <span v-if="remain > 0">({{ trans('phone.step2.remain_start') }} {{ remain }} s.)</span>
          </button>
        </div>
      </div>
    </div>
  </div>



</template>

<script>

import moment from "moment";

export default {
  name: "ChangePhoneComponent",
  props: {
    new_phone: {
      type: String,
      default: undefined,
    },
    expires_at: {
      default: undefined
    },
    refresh_at: {
      default: undefined
    },
    error: {
      type: String,
      default: undefined
    }
  },
  data: function () {
    return {
      phone: undefined,
      code: undefined,
      expiresTime: undefined,
      refreshTime: undefined,
      errorText: undefined,
      remain: 0,
      timer: undefined,
    }
  },
  mounted() {
    this.expiresTime = !!this.expires_at ? moment.utc(this.expires_at) : undefined
    this.refreshTime = this.refresh_at ? moment.utc(this.refresh_at) : undefined
    this.phone = this.new_phone
    this.errorText = this.error ?? undefined
  },
  watch: {
    refreshTime(value) {
      clearTimeout(this.timer)
      this.remain = !!value
        ? -moment().diff(value, 'seconds')
        : 0;
      if (this.remain > 0) {
        this.startTimer()
      }
    }
  },

  methods: {
    startTimer() {
      this.timer = setTimeout(() => {
        if (this.remain > 0) {
          this.remain--
          this.startTimer();
        }
      }, 1000);
    },

    enterPhone() {
      axios.put('/my/phone', {
        phone: this.phone,
      }).then((resp) => {
        this.expiresTime = moment.utc(resp.data.expiresAt)
        this.refreshTime = moment.utc(resp.data.refreshAt)
        this.phone = resp.data.phone
      }).catch((err) => {
        this.errorText = err.message ?? 'error'
      })
    },
    resetPhone() {
      axios.put('/my/phone/reset').then((resp) => {
        this.expiresTime = undefined
        this.refreshTime = undefined
        this.phone = undefined
      }).catch((err) => {
        this.errorText = err.message ?? 'error'
      })
    },
    enterCode() {
      axios.put('/my/phone/code', {
        code: this.code,
      }).then(() => {
        window.location.href = '/auctions'
      }).catch(err => {
        this.errorText = err.message ?? 'error'
      })
    },

  }
}
</script>

<style scoped>

</style>
